/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useHistory, withRouter } from 'react-router-dom'

import {
  Carregando,
  ErroLayoutContainer,
  IconeBack,
  Link
} from 'src/componentes'
import { TicketParceiroCertificacaoHistorico } from 'src/dto'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'
import { Api } from 'src/servicos'

import { Dados, ContainerLink, TituloPagina } from './styles'
import { HistoricoTicketProps } from './tipos'

export const PaginaHistoricoTicket: React.FC<HistoricoTicketProps> = ({
  match
}) => {
  const history = useHistory()
  const [ticket, definirTicket] = useState<TicketParceiroCertificacaoHistorico>(null)
  const [carregando, definirCarregando] = useState(true)

  const obterDados = async () => {
    try {
      definirCarregando(true)
      const id = match.params.idTicket
      const dados = await Api.ObterTicketParceiroCertificacaoPorId(id)
      definirTicket(dados)
    } catch (error) {
      console.error('Erro ao buscar ticket:', error)
    } finally {
      definirCarregando(false)
    }
  }

  useEffect(() => {
    obterDados()
  }, [])

  if (carregando) {
    return <Carregando texto="Carregando dados do ticket..." />
  }

  if (!ticket) {
    return <div>Ticket não encontrado</div>
  }

  const statusLabel =
    ticket.status === 'Concluido' ? 'Concluído' : ticket.status
  const categoriaLabel = ticket.categoria.replace(/([A-Z])/g, ' $1').trim()

  return (
    <>
      <ContainerLink>
        <Link
          texto="Voltar"
          acaoVoltar={() => history.goBack()}
          icone={IconeBack}
        />
      </ContainerLink>
      <TituloPagina>{`Detalhes do Ticket - ${ticket?.numeroProtocolo ?? ''}`}</TituloPagina>
      <Dados>
        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '4px' }}>
          <h3 style={{ marginBottom: '20px', color: '#333' }}>Informações do Ticket</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: '15px', marginBottom: '15px' }}>
            <div style={{ fontWeight: 'bold', color: '#666' }}>Protocolo:</div>
            <div>{ticket.numeroProtocolo}</div>

            <div style={{ fontWeight: 'bold', color: '#666' }}>Aluno:</div>
            <div>{ticket.nomeAluno || 'N/A'}</div>

            <div style={{ fontWeight: 'bold', color: '#666' }}>Categoria:</div>
            <div>{categoriaLabel}</div>

            <div style={{ fontWeight: 'bold', color: '#666' }}>Status:</div>
            <div>
              <span style={{
                padding: '4px 12px',
                borderRadius: '4px',
                backgroundColor: statusLabel === 'Pendente' ? '#fff3cd' : '#d4edda',
                color: statusLabel === 'Pendente' ? '#856404' : '#155724',
                fontSize: '14px'
              }}>
                {statusLabel}
              </span>
            </div>

            <div style={{ fontWeight: 'bold', color: '#666' }}>Nome do Arquivo:</div>
            <div>{ticket.nomeArquivo || 'N/A'}</div>

            <div style={{ fontWeight: 'bold', color: '#666' }}>Data de Criação:</div>
            <div>{ticket.dataCriacao ? formatadores.dataHoraLocaleString(ticket.dataCriacao) : 'N/A'}</div>

            {ticket.dataAtualizacao && (
              <>
                <div style={{ fontWeight: 'bold', color: '#666' }}>Data de Alteração:</div>
                <div>{formatadores.dataHoraLocaleString(ticket.dataAtualizacao)}</div>
              </>
            )}
          </div>

          {ticket.eventos && ticket.eventos.length > 0 && (
            <>
              <hr style={{ margin: '30px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />
              
              <h3 style={{ marginBottom: '20px', color: '#333' }}>Histórico de Eventos</h3>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {ticket.eventos
                  .sort((a, b) => new Date(b.dataCriacao).getTime() - new Date(a.dataCriacao).getTime())
                  .map((evento, index: number) => (
                    <div
                      key={index}
                      style={{
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        borderLeft: '4px solid #007bff',
                        borderRadius: '4px'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <div style={{ fontWeight: 'bold', color: '#007bff' }}>
                          {evento.nomeUsuario || 'Sistema'}
                        </div>
                        <div style={{ color: '#6c757d', fontSize: '14px' }}>
                          {formatadores.dataHoraLocaleString(evento.dataCriacao)}
                        </div>
                      </div>
                      
                      {evento.statusAnterior && (
                        <div style={{ marginBottom: '8px', fontSize: '14px', color: '#666' }}>
                          <strong>Status anterior:</strong> {evento.statusAnterior}
                        </div>
                      )}
                      
                      {evento.observacao && (
                        <div style={{ marginTop: '8px', color: '#333' }}>
                          {evento.observacao}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </Dados>
    </>
  )
}

const Container: React.FC<HistoricoTicketProps> = (
  props: HistoricoTicketProps
) => (
  <ErroLayoutContainer.Provider>
    <PaginaHistoricoTicket {...props} />
  </ErroLayoutContainer.Provider>
)

export default withRouter(Container)
